import { render, staticRenderFns } from "./DbpyRL.vue?vue&type=template&id=7d9bce53"
import script from "./DbpyRL.vue?vue&type=script&lang=js"
export * from "./DbpyRL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports